import React from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/styles";
const useStyle = makeStyles({
  formControl: {
    marginBottom: 0,
    minWidth: 120,
    width: "100%",
  },
  menuItem: {
    paddingLeft: "10px",
    textAlign: "left",
  },
});

const SelectBoxForDepartment = (props) => {
  const classes = useStyle();

  // const handleSelectOnChange = (event) => {
  //   const id = event.target.value;
  //   const option = props.options.filter((option) => option.id.id === id);
  //   //console.log("option:",option);
  //   props.select(...option);
  // };
  return (
    <FormControl className={classes.formControl}>
      <InputLabel>{props.label}</InputLabel>
      <Select
        required={props.required}
        value={props.value}
        // onChange={(event) => handleSelectOnChange(event)}
        onChange={(event) => props.select(event.target.value)}
        className={classes.menuItem}
      >
        {props.options.map((option, index) => (
          <MenuItem key={option.id} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectBoxForDepartment;
